import {FormControlLabel, Switch} from '@material-ui/core';
import React from 'react';
import {AgencySupportVisibilityPermission} from 'Users/models/AgencyAssociation';

type AgencySupportVisiblityListProps = {
  visibilityPermissions: AgencySupportVisibilityPermission[];
  onChange: (visibilityPermissions: AgencySupportVisibilityPermission[]) => void;
};

const PermissionSwitch = (props: {
  visibilityPermission: AgencySupportVisibilityPermission;
  visibilityPermissions: AgencySupportVisibilityPermission[];
  label: string;
  disabled?: boolean;
  onChange: (visibilityPermissions: AgencySupportVisibilityPermission[]) => void;
}) => {
  const hasPermission = (permission: AgencySupportVisibilityPermission) =>
    props.visibilityPermissions.includes(permission);
  return (
    <FormControlLabel
      control={
        <Switch
          color="primary"
          disabled={props.disabled}
          checked={hasPermission(props.visibilityPermission)}
          onChange={event => {
            props.onChange(
              event.target.checked
                ? [props.visibilityPermission, ...props.visibilityPermissions]
                : props.visibilityPermissions.filter(permission => permission !== props.visibilityPermission)
            );
          }}
        />
      }
      label={props.label}
    />
  );
};

const AgencySupportVisibilityList = (props: AgencySupportVisiblityListProps) => {
  return (
    <div>
      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.Account}
        label="View Accounts?"
      />
      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.Policies}
        label="View Policies?"
      />
      <PermissionSwitch
        disabled={!props.visibilityPermissions.includes(AgencySupportVisibilityPermission.Policies)}
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.Claims}
        label="View Claims?"
      />

      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.CommissionsAnd1099s}
        label="View Commissions and 1099s?"
      />

      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.PolicyServiceRequest}
        label="View Policy Service Request?"
      />

      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.Correspondence}
        label="View Correspondence?"
      />

      <PermissionSwitch
        visibilityPermissions={props.visibilityPermissions}
        onChange={props.onChange}
        visibilityPermission={AgencySupportVisibilityPermission.UnderwritingRequirements}
        label="View Underwriting Requirements?"
      />
    </div>
  );
};

export default AgencySupportVisibilityList;
